<template>
  <article class="post-preview">
    <div class="post-content" @click="openCard(post)">
      <img :src="post.image" style="height: 200px" />
      <h1>{{ post.title }}</h1>
      <p><b v-for="tag in post.tags" :key="tag">{{ tag }}</b></p>
      <p>{{ post.description.truncate(200) }}</p>
    </div>
  </article>
</template>

<script>

import Post from '@/components/Post'

export default {
  name: 'PostPreview',
  components: {
    // eslint-disable-next-line
    Post
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    openCard() {
      this.$buefy.modal.open({
          parent: this,
          component: Post,
          props: {'post': this.post}
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/main.scss';

.post-preview {
  border: 1px solid #ccc;
  box-shadow: 0 2px 2px #ccc;
  background-color: white;
  width: 90%;
}

a {
  text-decoration: none;
  color: black;
}

@media (min-width: 850px) {
  .post-preview {
    width: 400px;
    margin: 10px;
  }
}

.post-content {
  padding: 10px;
  text-align: center;
  height:360px;
  cursor: pointer;
}

.post-content h1 {
  font-size: 18px;
}

.post-content  {
  font-size: 12px;
}

.post-button  {
  font-size: 12px;
  float:right;
  margin:  0 20px 10px;
}

a:hover .post-content,
a:active .post-content {
  background-color: #ccc;
}
</style>
